export function getIP() { // 获取当前IP地址
  // eslint-disable-next-line no-undef
  let ip = returnCitySN["cip"];
  return ip;
}


// 判断是域名还是IP地址
function isIp() {
  let url = document.domain;
  var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; //正则表达式
  if (re.test(url)) {
    if (
      RegExp.$1 < 256 &&
      RegExp.$2 < 256 &&
      RegExp.$3 < 256 &&
      RegExp.$4 < 256
    )
      return true;
  }
  return false;
}

export function setToken(key, token) { // 设置存储token
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  // 87600小时过期 10年有效期
  addCookieAndDomain(key, token, 87600, domain);
  if (localStorage) {
    localStorage.setItem(key, token);
  }
}
// 设置cookie token
function addCookieAndDomain(key, value, objHours, strdomain) {
  let str = key + '=' + value + ';domain=' + strdomain;
  if (objHours > 0) {
    let date = new Date();
    let ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += ';expires=' + date.toGMTString() + ';path=/';
  } else {
    str += ';path=/';
  }
  document.cookie = str;
}
// 获取顶级域名
// function getTopDomain(domainStr) {
//   let pattern
//   if (process.env.NODE_ENV === 'production') {
//     pattern = /.iyw.cn/;
//   } else {
//     pattern = /.iywtu.com/;
//   }
//   if (pattern.test(domainStr)) {
//     return domainStr.match(pattern);
//   } else {
//     return domainStr;
//   }
//   // return document.domain.split('.').slice(-2).join('.')
// }

// 删除token
export function removeToken() {
  clearCookie();
  return localStorage.clear()
}
function clearCookie() {
  // eslint-disable-next-line no-useless-escape
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=' + domain;
    }
  }
}

// 获取token
export function getToken(key) {
  return localStorage.getItem(key)
  // let cookieStr = document.cookie
  // if (cookieStr.length > 0) {
  //   let arrCookie = cookieStr.split("; ")
  //   for (const val of arrCookie) {
  //     let arr = val.split("=")
  //     if (arr[0] === key) {
  //       return arr[1]
  //     }
  //   }
  // }
  // return ""
}

// 设置cookie
export function setCookieVal(key, val, time = 2) {
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  addCookieAndDomain(key, val, time, domain);
}

// 获取cookie
export function getCookieVal(key) {
  let cookieStr = document.cookie
  if (cookieStr.length > 0) {
    let arrCookie = cookieStr.split("; ")
    for (const val of arrCookie) {
      let arr = val.split("=")
      if (arr[0] === key) {
        return arr[1]
      }
    }
  }
  return ""
}

// 账号名验证
export function usernameVerify(rule, val, callback) {
  if (!val) {
    callback(new Error("请输入账号名"))
  } else {
    let reg2 = /\d{5}/
    let isNum = /^\d+$/
    let isMail = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-z\d]+[-.])+[A-Za-zd]{2,5}$/
    if (isMail.test(val)) {
      callback(new Error("账号名不能使用邮箱格式"))
      return
    }
    if (val.length < 2) {
      callback(new Error("账号名不能少于2位"))
    } else {
      if (reg2.test(val)) {
        callback(new Error("账号名不能出现连续5个数字"))
      } else {
        if (isNum.test(val)) {
          callback(new Error("账号名不能纯数字"))
        } else {
          callback()
        }
      }
    }
  }
}

// 昵称验证
export function nickNameVerify(rule, val, callback) {
  if (!val) {
    callback(new Error("请输入昵称"))
  } else {
    let reg2 = /\d{5}/
    let isNum = /^\d+$/
    let isMail = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-z\d]+[-.])+[A-Za-zd]{2,5}$/
    if (isMail.test(val)) {
      callback(new Error("昵称不能使用邮箱格式"))
      return
    }
    if (val.length < 2) {
      callback(new Error("昵称不能少于2位"))
    } else {
      if (reg2.test(val)) {
        callback(new Error("昵称不能出现连续5个数字"))
      } else {
        if (isNum.test(val)) {
          callback(new Error("昵称不能纯数字"))
        } else {
          callback()
        }
      }
    }
  }
}


// 手机验证
export function phoneVerify(rule, val, callback) {
  if (!val) {
    callback(new Error("请输入手机号"))
  } else {
    let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (reg.test(val)) {
      callback()
    } else {
      callback(new Error("请输入正确的手机号"))
    }
  }
}

// 邮箱验证
export function mailVerify(rule, val, callback) {
  if (!val) {
    callback(new Error("请输入邮箱地址"))
  } else {
    let reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-z\d]+[-.])+[A-Za-zd]{2,5}$/
    if (reg.test(val)) {
      callback()
    } else {
      callback(new Error("请输入正确的邮箱地址"))
    }
  }
}

// 密码验证
export function pswVerify(rule, val, callback) {
  if (!val) {
    callback(new Error("请输入密码"))
  } else {
    let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,25}$/
    if (reg.test(val)) {
      callback()
    } else {
      callback(new Error("混合使用字母、数字特殊符号组合(至少包含2种)"))
    }
  }
}

// 递归方法
export function getTreeData(data) {
  // 循环遍历json数据
  for (let i = 0; i < data.length; i++) {
    if (data[i].children && !data[i].children.length) {
      // children若为空数组，则将children设为undefined
      data[i].children = undefined;
    } else if (data[i].children && data[i].children.length) {
      // children若不为空数组，则继续 递归调用 本方法
      getTreeData(data[i].children);
    }
  }
  return data;
}

// 地区数据
export function setCascaderData(array, keyArr, data) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    let obj = getRecursionData(array, item[item.length - 1]);
    if (obj && Object.values(obj).length > 0) {
      arr = arr.concat({
        [keyArr[0]]: obj.id,
        [keyArr[1]]: obj.chLabel
      });
    }
  }
  return arr;
}

// 根据ID找到对应的数据
export function getRecursionData(arr, id) {
  const len = arr.length;
  let audit;
  if (id) {
    for (let i = 0; i < len; i++) {
      if (id === arr[i].id) {
        audit = arr[i];
        break;
      } else if (arr[i].children && arr[i].children.length) {
        audit = getRecursionData(arr[i].children, id);
        if (audit) break; // 找到就结束循环，避免后续循环覆盖正确结果
      }
    }
  }
  return audit;
}
